import { useEffect, useState } from "react";
import client from "@/lib/api";
import Loader from "@/components/Loader";
import usePageTitle from "@/hooks/usePageTitle";

export default function Gallery() {
  const [items, setItems] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  usePageTitle("Gallery", "Chess events, business engagements, speaking appearances and federation moments featuring Shri Nitin Narang.");

  useEffect(() => { client.get("/gallery").then(r => setItems(r.data.items)); }, []);

  return (
    <main className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
      <div className="mb-16">
        <div className="eyebrow mb-4">Gallery</div>
        <h1 className="serif-title text-5xl lg:text-6xl text-[#0a1628] mb-4">In public, in office.</h1>
        <p className="text-[#4a4a4a] text-[17px] leading-relaxed max-w-3xl">
          Chess events, business engagements, speaking appearances and federation moments.
        </p>
      </div>

      {!items ? <Loader label="Loading gallery" /> : (
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map(g => (
            <button key={g.id}
              onClick={() => setLightbox(g)}
              className="aspect-square overflow-hidden border hairline bg-[#ece7da] group relative">
              <img src={g.image} alt={g.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"/>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <div className="text-[#faf8f3]">
                  <div className="eyebrow text-[#b8975d] mb-1">{g.category}</div>
                  <div className="font-display text-sm">{g.title}</div>
                </div>
              </div>
            </button>
          ))}
          {items.length === 0 && (
            <div className="col-span-full text-center py-20 text-[#6b6b6b] border hairline">
              <p>Gallery items will appear here as they are added by the office.</p>
            </div>
          )}
        </div>
      )}

      {lightbox && (
        <div onClick={() => setLightbox(null)} className="fixed inset-0 bg-[rgba(10,22,40,0.92)] z-[100] flex items-center justify-center p-6 cursor-pointer">
          <div onClick={(e) => e.stopPropagation()} className="max-w-5xl w-full cursor-default">
            <img src={lightbox.image} alt={lightbox.title} className="w-full max-h-[80vh] object-contain"/>
            <div className="mt-4 text-[#faf8f3]">
              <div className="eyebrow text-[#b8975d] mb-1">{lightbox.category}</div>
              <div className="font-display text-2xl">{lightbox.title}</div>
              {lightbox.caption && <p className="text-[#cfc6b3] text-[14px] mt-2">{lightbox.caption}</p>}
            </div>
          </div>
          <button onClick={() => setLightbox(null)} className="absolute top-6 right-6 w-10 h-10 border border-[rgba(255,255,255,0.3)] text-[#faf8f3] hover:bg-[#faf8f3] hover:text-[#0a1628]">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
      )}
    </main>
  );
}
